import { PhotographIcon } from '@heroicons/react/solid'
import React, { FC, useState } from 'react'

type Props = {
  src: string;
  alt?: string;
}

const IssueListImage: FC<Props> = ({ src, alt }) => {
  const [imageSrc, setImageSrc] = useState(src)
  const [isBroken, setIsBroken] = useState(false)

  return (
    <>
      {!isBroken && <img src={imageSrc} alt={alt} onError={() => setIsBroken(true)} />}
      {isBroken && <PhotographIcon className="empty-icon" />}
    </>
  )
}

export default IssueListImage
